export default {
  props: {
    topActionsData: Object,
  },
};
